import { formatOdds } from '../utils';

export interface FormattedSelectionOdds {
    formattedOdds: string | boolean;
    formattedPrevOdds: string | boolean;
}

export const useFormattedOdds = (odds: number, prevOdds: number): FormattedSelectionOdds => {
    return { formattedOdds: formatOdds(odds), formattedPrevOdds: formatOdds(prevOdds) };
};
